import { ActionsInboxView } from '../features/actions-inbox/ActionsInboxView';

export function ActionsInboxPage() {
  return (
    <div className='p-6'>
      <ActionsInboxView />
    </div>
  );
}

export default ActionsInboxPage;
